import { ReactNode } from "react";
import { Link } from "react-router-dom";
import * as css from "./redo-table-cell-link.module.css";

/** A table-cell anchor: open-in-new-tab support that doesn't also fire onRowClick. */
export function RedoTableCellLink({
  to,
  target,
  children,
  "data-dd-action-name": actionName,
}: {
  to: string;
  target?: "_blank";
  children: ReactNode;
  "data-dd-action-name"?: string;
}) {
  return (
    <Link
      className={css.link}
      data-arbiter="RedoTableCellLink"
      data-dd-action-name={actionName}
      onClick={(e) => e.stopPropagation()}
      rel={target === "_blank" ? "noreferrer" : undefined}
      target={target}
      to={to}
    >
      {children}
    </Link>
  );
}
